import { usePatients, useVisits, type VisitDto } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo, useRef } from "react";
import { PatientsList } from "@/features/patients";

export const Route = createFileRoute("/patients/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { patients } = usePatients();
  const { visits } = useVisits({ excludeStatus: ["cancelled", "noShow"] });
  const nowRef = useRef(new Date().toISOString());

  const nextVisits = useMemo(() => {
    const map = new Map<string, VisitDto>();
    for (const v of visits) {
      if (!v.patientId || !v.start) continue;

      const isArrived = v.status === "inProgress" || v.status === "checkedIn";
      const isFuture = v.start >= nowRef.current;
      const isActiveWindow = !isFuture && v.end != null && v.end >= nowRef.current && v.status === "booked";

      if (!isFuture && !isArrived && !isActiveWindow) continue;

      const priority = isArrived ? 2 : isActiveWindow ? 1 : 0;
      const existing = map.get(v.patientId);
      const existingPriority = !existing
        ? -1
        : existing.status === "inProgress" || existing.status === "checkedIn"
          ? 2
          : existing.start && existing.start < nowRef.current
            ? 1
            : 0;

      if (priority > existingPriority || (priority === existingPriority && v.start < (existing?.start ?? ""))) {
        map.set(v.patientId, v);
      }
    }
    return map;
  }, [visits]);

  return (
    <div className="h-full flex flex-col">
      <PatientsList patients={patients} nextVisits={nextVisits} />
    </div>
  );
}
